module.exports = __webpack_public_path__ + "img/paysafecard.02affa1f.png";